import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NewHeaderNavWithSidebar from '../HeaderNav/NewHeaderNavWithSidebar';
import { useUser } from '../../context/UserContext';
import { CircularProgress, Box } from '@mui/material';
import { colors } from '../../ColorFont/color';

import { AnimatePresence, motion } from 'framer-motion';

const pathTitleMap = {
    '/dashboard': 'Dashboard',
    '/home': 'Dashboard',
    '/my-crops': 'My Crops',
    '/pricing': 'Pricing',
    '/add-crop-step-1': 'Crop Category',
    '/photos': 'Photos',
    '/location-delivery': 'Location & Delivery',
    '/carbon-credits': 'Carbon Credits',
    '/carbon-credits/farm-details': 'Farm Details',
    '/carbon-credits/practices': 'Practices',
    '/carbon-credits/timeline': 'Timeline',
    '/carbon-credits/review': 'Review',
    '/carbon-credits/upload-proof': 'Upload Proof',
    '/carbon-credits/wallet': 'My Wallet',
    '/carbon-credits/all-projects': 'Your Projects',
    '/carbon-credits/my-proofs': 'Project Proofs',
    '/carbon-credits/sell-credit': 'Sell Credit',
    '/farmer/boost': 'Boost Your Listing',
    '/profile': 'Profile',
    '/farmer/profile': 'Profile',
    '/buyer/boost': 'Plans & Pricing',
    '/wishlist': 'My Wishlist',
    '/about': 'About Us',
    '/support': 'Support',
    '/settings': 'Settings',
    '/faqs': 'FAQs',
    '/purchase-history': 'Purchase History',
    '/viewed-plots': 'Viewed Plots',
    '/explore': 'Explore',
};

const MainLayout = () => {
    const location = useLocation();
    const { loading } = useUser();
    
    const title = pathTitleMap[location.pathname] || 'KrushiSetu';

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: colors.primary }} />
            </Box>
        );
    }

    return (
        <NewHeaderNavWithSidebar headerTitle={title} activeSegment={location.pathname}>
            <AnimatePresence mode="wait">
                <motion.div
                    key={location.pathname}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    style={{ width: '100%' }}
                >
                    <Outlet />
                </motion.div>
            </AnimatePresence>
        </NewHeaderNavWithSidebar>
    );
};

export default React.memo(MainLayout);
